export const SHOP = {
  name: "The Sweet Shop Bakery",
  phone: "7323378021",
  phoneDisplay: "(732) 337-8021",
  email: "Robert.burkem06@gmail.com",
};

const c = (id, name, tags, image, items, extra = {}) => ({ id, name, tags, image, items, ...extra });

export const CATEGORIES = [
  c("cake-pops", "Cake Pops", ["Classic", "Gourmet", "Party Pops"], "/img/cakepops.jpg", [
    "Vanilla cake with vanilla frosting", "Chocolate fudge", "Red velvet", "Birthday cake and rainbow sprinkles",
    "Cookies and cream", "Chocolate peanut butter", "Strawberry shortcake", "Lemon cake", "Caramel crunch", "S'mores",
    "Oreo cheesecake", "Chocolate-covered cake pops with drizzles", "Holiday, baby shower, and custom-decorated pops",
  ]),
  c("mini-donuts", "Mini Donuts", ["Fresh", "Glazed", "Loaded"], "/img/donuts.jpg", [
    "Classic glazed", "Powdered sugar", "Cinnamon sugar", "Chocolate glaze", "Vanilla glaze with sprinkles",
    "Strawberry icing", "Maple glaze", "Cookies and cream", "S'mores", "Salted caramel", "Peanut butter chocolate",
    "Fruity cereal crunch", "Birthday cake", "Apple cinnamon", "Mini donut sampler boxes",
  ]),
  c("mini-bundt-cakes", "Mini Bundt Cakes", ["Moist", "Rich", "Drizzled"], "/img/bundt.jpg", [
    "Classic vanilla", "Double chocolate", "Red velvet with cream cheese icing", "Lemon glaze", "Strawberry swirl",
    "Marble cake", "Carrot cake with cream cheese icing", "Banana pudding", "Cookies and cream", "Chocolate peanut butter",
    "Salted caramel", "Cinnamon roll", "Funfetti", "Pumpkin spice seasonal bundts", "Custom birthday bundt cakes",
  ]),
  c("strawberries", "Chocolate-Covered Strawberries", ["Fresh", "Dipped", "Decorated"], "/img/strawberries.jpg", [
    "Classic milk chocolate", "Dark chocolate", "White chocolate", "Pink chocolate", "Cookies and cream crumble",
    "Chocolate drizzle", "White chocolate with dark drizzle", "Crushed Oreo", "Crushed pretzel", "Chocolate chip topping",
    "Rainbow sprinkles", "Coconut flakes", "Caramel drizzle", "Peanut butter drizzle", "Birthday-themed berries",
    "Valentine's Day and anniversary boxes", "Luxury tuxedo strawberries",
  ]),
  c("gourmet-cookies", "Big Gourmet Cookies", ["Thick", "Gooey", "Loaded"], "/img/cookies.jpg", [
    "Classic giant chocolate chip", "Double chocolate chunk", "Triple chocolate", "White chocolate macadamia",
    "Cookies and cream", "Peanut butter chocolate chip", "S'mores stuffed cookies", "Birthday cake cookies",
    "Red velvet white chocolate", "Salted caramel chocolate", "Brownie cookies", "Nutella-stuffed cookies",
    "Peanut butter cup cookies", "M&M candy cookies", "Chocolate chip walnut", "Strawberry cheesecake cookies",
    "Cinnamon roll cookies", "Seasonal pumpkin chocolate chip",
  ]),
  c("cupcakes", "Cupcakes", ["Classic", "Filled", "Custom"], "/img/cupcakes.jpg", [], {
    builder: {
      cake: ["Vanilla", "Chocolate", "Marble", "Red velvet", "Strawberry", "Lemon", "Funfetti", "Cookies and cream",
        "Chocolate fudge", "Carrot cake", "Banana pudding", "Coconut", "Salted caramel"],
      frosting: ["Vanilla buttercream", "Chocolate buttercream", "Cream cheese", "Strawberry", "Peanut butter",
        "Cookies and cream", "Lemon", "Salted caramel", "Cookie dough", "Whipped chocolate ganache"],
      filling: ["No filling", "Oreo cream", "Raspberry", "Strawberry", "Caramel", "Chocolate ganache", "Peanut butter"],
    },
  }),
  c("chocolate-lollipops", "Chocolate Lollipops", ["Cute", "Colorful", "Custom"], "/img/lollipops.jpg", [
    "Milk chocolate circles", "White chocolate lollipops", "Dark chocolate pops", "Pink and blue chocolate pops",
    "Rainbow sprinkle pops", "Chocolate hearts", "Chocolate stars", "Chocolate flowers", "Oreo-crunch chocolate pops",
    "Peanut butter chocolate pops", "Birthday number pops", "Baby shower designs", "Wedding favors",
    "Custom names, initials, and themed designs",
  ]),
  c("pretzels", "Chocolate-Covered Pretzels", ["Sweet", "Salty", "Crunchy"], "/img/pretzels.jpg", [
    "Milk chocolate pretzel rods", "Dark chocolate pretzels", "White chocolate pretzels", "Cookies and cream",
    "Caramel drizzle", "Peanut butter drizzle", "Strawberry drizzle", "Birthday sprinkle pretzels", "Crushed Oreo",
    "S'mores pretzels", "Crushed candy topping", "Chocolate and toffee crunch", "Holiday-colored pretzels",
    "Gourmet pretzel gift boxes",
  ]),
  c("brownies-blondies", "Brownies & Blondies", ["Fudgy", "Chewy", "Swirled"], "/img/brownies.jpg", [
    "Fudge brownies", "Oreo brownies", "Peanut butter swirl", "Salted caramel brownies", "Blondies with white chocolate", "Brookies",
  ]),
  c("dipped-oreos", "Chocolate-Dipped Oreos", ["Dipped", "Drizzled", "Custom"], "/img/oreos.jpg", [
    "Milk chocolate", "White chocolate", "Cookies and cream", "Birthday sprinkles", "Caramel drizzle", "Custom designs",
  ]),
  c("rice-crispy-treats", "Rice Crispy Treats", ["Gooey", "Crispy", "Dipped"], "/img/crispy.jpg", [
    "Original marshmallow", "Chocolate dipped", "Cookies and cream", "Fruity cereal", "Peanut butter chocolate", "Birthday cake",
  ]),
  c("dessert-cups", "Dessert Cups", ["Layered", "Creamy", "Spoonable"], "/img/cups.jpg", [
    "Banana pudding", "Strawberry cheesecake", "Chocolate mousse", "Oreo cheesecake", "Red velvet parfait", "Brownie sundae cups",
  ]),
  c("marshmallow-pops", "Marshmallow Pops", ["Fluffy", "Dipped", "Festive"], "/img/marshmallow.jpg", [
    "Chocolate dipped", "S'mores", "Birthday sprinkle", "Cookies and cream", "Caramel drizzle", "Holiday pops",
  ]),
  c("dessert-boxes", "Custom Dessert Boxes", ["Curated", "Giftable", "Yours"], "/img/box.jpg", [
    "Chocolate lover's box", "Cookie sampler", "Strawberry gift box", "Birthday box", "Date night box", "Build-your-own treat box",
  ]),
];

export const findCategory = (id) => CATEGORIES.find((x) => x.id === id);
